import { bidlClient } from 'src/utils/api'
import { tryQuery } from 'src/utils/queries'

type Configuration = {
  key: string
  value: string
}

type UpdateConfigurationRequest = {
  configurations: Configuration[]
}

export const GetConfigurables = async (baseUri: string, tenantId: string, slug: string) =>
  tryQuery(
    bidlClient.post(
      `${baseUri}/GetConfigurables`,
      {},
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
          'App-Company': slug,
        },
      }
    )
  )

export const FindOrCreateTenantConfiguration = async (
  baseUri: string,
  tenantId: string,
  slug: string
) =>
  tryQuery(
    bidlClient.post(
      `${baseUri}/FindOrCreateTenantConfiguration`,
      {},
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
          'App-Company': slug,
        },
      }
    )
  )

export const UpdateTenantConfiguration = async (
  baseUri: string,
  config: UpdateConfigurationRequest,
  tenantId: string,
  slug: string
) =>
  tryQuery(
    bidlClient.post(`${baseUri}/UpdateTenantConfiguration`, JSON.stringify(config), {
      headers: {
        'Content-Type': 'application/json',
        'X-Bushel-Tenant': tenantId,
        'App-Company': slug,
      },
    })
  )
